import React, { useState, useEffect } from 'react';
import PantallaInicial from './components/PantallaInicial';
import ListadoCandidatos from './components/ListadoCandidatos';
import TuSeleccion from './components/TuSeleccion';

// Estados de flujo
const FLUJOS = {
  INICIO: 'INICIO',
  LISTADO: 'LISTADO',
  SELECCION: 'SELECCION',
};

// Clave para el localStorage
const STORAGE_KEY = 'cancha_electoral_seleccion';

function App() {
  const [flujo, setFlujo] = useState(FLUJOS.INICIO);
  const [seleccion, setSeleccion] = useState(() => {
    // Intentar cargar la selección guardada al iniciar
    const seleccionGuardada = localStorage.getItem(STORAGE_KEY);
    if (seleccionGuardada) {
      try {
        return JSON.parse(seleccionGuardada);
      } catch (e) {
        console.error('Error al cargar la selección guardada:', e);
      }
    }
    // Si no hay selección guardada o hay error, usar el estado inicial
    return {
      suprema_corte: [],
      tribunal_disciplina: [],
      tribunal_electoral: []
    };
  });
  const [canchaSeleccionada, setCanchaSeleccionada] = useState(null);

  // Guardar la selección en localStorage cada vez que cambie
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(seleccion));
    } catch (e) {
      console.error('Error al guardar la selección:', e);
    }
  }, [seleccion]);

  // Navegación entre pantallas
  const handleSeleccionCancha = (cancha) => {
    setCanchaSeleccionada(cancha);
    setFlujo(FLUJOS.LISTADO);
  };

  const handleIrASeleccion = () => {
    setFlujo(FLUJOS.SELECCION);
  };

  const handleSeleccionCandidatos = (candidatos) => {
    setSeleccion(prev => ({
      ...prev,
      [canchaSeleccionada]: candidatos
    }));
    setCanchaSeleccionada(null);
    setFlujo(FLUJOS.SELECCION);
  };

  const handleEditarCancha = (cancha) => {
    setCanchaSeleccionada(cancha);
    setFlujo(FLUJOS.LISTADO);
  };

  return (
    <div className="App">
      {flujo === FLUJOS.INICIO && (
        <PantallaInicial 
          onSeleccionCancha={handleSeleccionCancha} 
          onIrASeleccion={handleIrASeleccion}
        />
      )}
      {flujo === FLUJOS.LISTADO && canchaSeleccionada && (
        <ListadoCandidatos
          canchaSeleccionada={canchaSeleccionada}
          seleccion={seleccion[canchaSeleccionada] || []}
          onSeleccionCandidatos={handleSeleccionCandidatos}
          onAtras={() => setFlujo(FLUJOS.INICIO)}
        />
      )}
      {flujo === FLUJOS.SELECCION && (
        <TuSeleccion seleccion={seleccion} onEditarCancha={handleEditarCancha} />
      )}
    </div>
  );
}

export default App; 